import React from 'react';
import { Link } from 'react-router-dom';

const AboutUs = () => {
    return (
        <section className='about-us'>
            <h4>About Our Laptop Store</h4>

            <p>
                We are a team of computer enthusiasts who are dedicated to providing the best
                laptop shopping experience to our customers. Our mission is to offer a wide
                variety of high-quality laptops from top brands at affordable prices.
            </p>

            <p>
                Our store is committed to providing excellent customer service, and we are always
                happy to help with any questions or concerns you may have about your purchase.
                We believe that buying a laptop should be an enjoyable experience, and we strive
                to make it as easy and hassle-free as possible.
            </p>

            <p>
                Our goal is to help our customers find the perfect laptop to meet their needs,
                whether it's for work, gaming, or everyday use. We offer a range of laptops with
                different specifications and features, so there's something for everyone.
            </p>

            <p>
                Thank you for choosing our store as your go-to online laptop shopping destination.
                We appreciate your business and look forward to serving you!
            </p>

            <button className="about-us-btn">
                <Link to="/contact" onClick={() => {
                    window.scroll({
                        top: 0,
                        left: 0,
                        behavior: "smooth",
                    });
                }}>
                    Contact Us
                </Link>
            </button>
        </section>
    );
};

export default AboutUs;